import { useState } from "react";
import { Button, Empty, Modal, Space } from "antd";

export interface EventLogEntry {
  id: number;
  timestamp: number;
  name: string;
  payload: unknown;
}

export interface EventLogProps {
  events: readonly EventLogEntry[];
  onClear: () => void;
  title?: string;
}

const EventLog = ({ events, onClear, title = "Chat events" }: EventLogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>Events ({events.length})</Button>
      <Modal
        title={title}
        open={open}
        onCancel={() => setOpen(false)}
        width={800}
        footer={
          <Space>
            <Button onClick={onClear} disabled={events.length === 0}>Clear</Button>
            <Button onClick={() => setOpen(false)}>Close</Button>
          </Space>
        }
      >
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {events.length === 0 ? (
            <Empty description="No events recorded yet" />
          ) : (
            events.map((event) => (
              <div key={event.id} style={{ padding: "12px 0", borderBottom: "1px solid #f0f0f0" }}>
                <Space wrap>
                  <strong>{event.name}</strong>
                  <time dateTime={new Date(event.timestamp).toISOString()}>
                    {new Date(event.timestamp).toLocaleTimeString('en-US', {
                      hour: "2-digit", minute: "2-digit", second: "2-digit"
                    })}
                  </time>
                </Space>
                <pre style={{ margin: "8px 0 0", whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                  {JSON.stringify(event.payload, null, 2)}
                </pre>
              </div>
            ))
          )}
        </div>
      </Modal>
    </>
  );
};

export default EventLog;
